module.exports = __webpack_public_path__ + "293089ddf339ad12d51c5769c0a09cde.svg";